import {
  Box,
  ButtonBase,
  ClickAwayListener,
  Stack,
  TextField,
} from "@mui/material";
import {BlockPicker} from "react-color";
import {useState} from "react";
import * as muiColors from "@mui/material/colors";

type Props = {
  label: string;
  value: string | null | undefined;
  errorMsg?: string;
  disabled?: boolean;
  colors?: string[];
  onChange: (color: string) => void;
};

const defColors = [
  muiColors.amber[500],
  muiColors.blue[500],
  muiColors.blueGrey[500],
  muiColors.brown[500],
  muiColors.cyan[500],
  muiColors.deepOrange[500],
  muiColors.deepPurple[500],
  muiColors.green[500],
  muiColors.grey[500],
  muiColors.indigo[500],
  muiColors.lightBlue[500],
  muiColors.lightGreen[500],
  muiColors.lime[500],
  muiColors.orange[500],
  muiColors.pink[500],
  muiColors.purple[500],
  muiColors.red[500],
  muiColors.teal[500],
  muiColors.yellow[500],
];

export default function ColorPicker(props: Props) {
  const [open, setOpen] = useState<boolean>(false);

  const {colors, label, value, errorMsg, disabled, onChange} = props;

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <TextField
        variant="standard"
        label={label}
        value={value ?? ""}
        error={errorMsg !== undefined}
        helperText={errorMsg}
        disabled
      />
      <ButtonBase
        disabled={disabled}
        onClick={() => setOpen(true)}
        sx={{
          backgroundColor: disabled ? "lightgray" : value,
          p: 2,
          borderRadius: 2,
          width: 2,
          position: "relative",
          cursor: "pointer",
          border: "1px solid lightgray",
        }}>
        {open && (
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Box
              sx={{
                position: "absolute",
                zIndex: 99999,
                top: 48,
                cursor: "default",
              }}>
              <BlockPicker
                color={value ?? defColors[0]}
                onChangeComplete={color => onChange(color.hex)}
                colors={colors ?? defColors}
              />
            </Box>
          </ClickAwayListener>
        )}
      </ButtonBase>
    </Stack>
  );
}
